<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Комментарии к препаратам</h5>
      </div>
      <div class="card-body">
        <div class="filter"></div>
        <pulse-loader :loading="loading.general" :color="$constants.LOADING_COLOR" class="text-center"/>
        <table class="table mt-0 table-sm table-hover">
          <thead>
          <tr>
            <th></th>
            <th width="20%">Препарат</th>
            <th>Комментарий</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(r, i) in records" :class="{bg_danger: hasOverDueDate(details[r.id]?.date_value)}">
            <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
            <td>{{ r.title }} ({{ r.id }})</td>
            <td>
              <DrugCommentsBlock :allowToSave="true" :disableStartNewRecord="true" :detail="details[r.id]" ref="drugsManagersComments"/>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import DrugCommentsBlock from "@/views/nomenclature/components/DrugCommentsBlock.vue";
import moment from 'moment';

export default {
  components: {DrugCommentsBlock, Paginate},
  data() {
    return {
      loading: {
        general: false
      },
      paginator: null,
      records: [],
      details: {},
      filter: {},
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    hasOverDueDate(date = null) {
      if (!date) return false;
      return moment() > moment(date);
    },
    async getRecords(page = 1) {
      this.loading.general = true;
      let {data: r_data} = await api.index('/new/nomenclature/drug/comments?page=' + page);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination
        this.details = data.reduce((acc, r) => {
          acc[r.id] = r.details.find((d) => d.group_alias === 'managers_info' && d.alias === 'comments');
          return acc;
        }, {})
        this.records = _.orderBy(data.map((r) => {
          return {...r, sortDate: this.details[r.id]?.date_value}
        }), 'sortDate', 'asc');
      }
      this.loading.general = false;
    }
  }
}

</script>
